"use client";

import { Button } from "@heroui/button";
import {
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from "@heroui/modal";

interface ClaimConfirmationDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmText: string;
  cancelText?: string;
  variant?: "danger" | "success" | "primary";
  isLoading?: boolean;
}

export function ClaimConfirmationDialog({
  cancelText = "Cancel",
  confirmText,
  isLoading = false,
  isOpen,
  message,
  onClose,
  onConfirm,
  title,
  variant = "danger",
}: ClaimConfirmationDialogProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalContent>
        <ModalHeader>{title}</ModalHeader>
        <ModalBody>
          <p className="text-default-600">{message}</p>
        </ModalBody>
        <ModalFooter>
          <Button
            color="default"
            isDisabled={isLoading}
            variant="flat"
            onPress={onClose}
          >
            {cancelText}
          </Button>
          <Button color={variant} isLoading={isLoading} onPress={onConfirm}>
            {confirmText}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
